import PropTypes from 'prop-types';

const CombineProvider = ({ children, providers }) =>
  providers.filter(Boolean).reduceRight(
    (result, item) => {
      const { provider: Provider, ...otherProps } = item;

      return <Provider {...otherProps}>{result}</Provider>;
    },
    <>{children}</>,
  );

CombineProvider.propTypes = {
  providers: PropTypes.array.isRequired,
  children: PropTypes.node,
};

export default CombineProvider;
